import PropTypes from 'prop-types'
import { formatearFecha, formatearMonto } from '../../helpers/helper'

const FACTOR_MONTO_PLAN_BASICO = 3
const FACTOR_MONTO_PLAN_INTERMEDIO = 2
const PLAN_INTERMEDIO_ID = 2
const DIVISOR_PORCENTAJE_PLAN_BASICO = 3
const DIVISOR_PORCENTAJE_PLAN_INTERMEDIO = 1.5

const InformacionPlan = ({ tienda, planes, nuevoPlan }) => {
  const fecha = new Date()
  const fechaHasta = new Date(fecha)
  fechaHasta.setMonth(fecha.getMonth() + tienda.duracionMeses)

  return (
    <div className="col-12 col-lg">
      <h3>Información del Plan Seleccionado</h3>
      <div className="ml-2">
        <ul>
          <li className="datos-perfil border-green-2px" id="liDatosPerfil">
            <div className="flex-d-row">
              <i className="fa fa-check-circle f-ebm-green" aria-hidden="true" />
              <div id="titulo-plan">Plan</div>
            </div>
            <div>
              {nuevoPlan
                ? planes.find((plan) => plan.idTiendaOficialPlan === nuevoPlan)?.nombre
                : tienda.nombre}
            </div>
          </li>
          <li className="datos-perfil no-modificable" id="liDatosPerfil">
            <span className="float-left">Fecha de Validez</span>&nbsp;
            <span className="float-right">
              desde &nbsp;
              {tienda.idTiendaOficialEstado === 1
                ? formatearFecha(fecha, 'F')
                : formatearFecha(tienda.fechaDesde, 'F')}
              - hasta &nbsp;
              {tienda.idTiendaOficialEstado === 1
                ? formatearFecha(fechaHasta, 'F')
                : formatearFecha(tienda.fechaHasta, 'F')}
            </span>
          </li>
          <li className="datos-perfil no-modificable" id="liDatosPerfil">
            <span className="float-left">Monto Fijo</span>&nbsp;
            <span className="float-right">
              {' '}
              {/* Hago esto a continuación fines de la demo únicamente. ESTÁ MAL!!! hay que hacerlo bien. */}
              {formatearMonto(
                nuevoPlan && nuevoPlan === 1
                  ? tienda.montoFijo * FACTOR_MONTO_PLAN_BASICO
                  : nuevoPlan && nuevoPlan === PLAN_INTERMEDIO_ID
                    ? tienda.montoFijo * FACTOR_MONTO_PLAN_INTERMEDIO
                    : tienda.montoFijo,
                '$'
              )}
            </span>
          </li>
          <li className="datos-perfil no-modificable" id="liDatosPerfil">
            <span className="float-left">Porcentaje</span>&nbsp;
            {/* Hago esto a continuación fines de la demo únicamente. ESTÁ MAL!!! hay que hacerlo bien. */}
            <span className="float-right">
              {nuevoPlan && nuevoPlan === 1
                ? tienda.porcentajeVenta / DIVISOR_PORCENTAJE_PLAN_BASICO
                : nuevoPlan && nuevoPlan === PLAN_INTERMEDIO_ID
                  ? tienda.porcentajeVenta / DIVISOR_PORCENTAJE_PLAN_INTERMEDIO
                  : tienda.porcentajeVenta}
            </span>
          </li>
        </ul>
      </div>
    </div>
  )
}

InformacionPlan.propTypes = {
  tienda: PropTypes.shape({
    duracionMeses: PropTypes.number,
    nombre: PropTypes.string,
    idTiendaOficialEstado: PropTypes.number,
    fechaDesde: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    fechaHasta: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    montoFijo: PropTypes.number,
    porcentajeVenta: PropTypes.number
  }).isRequired,
  planes: PropTypes.arrayOf(
    PropTypes.shape({
      idTiendaOficialPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      nombre: PropTypes.string.isRequired
    })
  ).isRequired,
  nuevoPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default InformacionPlan
